import clsx from 'clsx'

export default function Skeleton({ className }) {
  return <div className={clsx('skeleton-shimmer rounded-md', className)} />
}

export function SkeletonCard() {
  return (
    <div className="rounded-lg border border-line bg-panel p-4">
      <Skeleton className="h-32 w-full mb-3" />
      <Skeleton className="h-4 w-3/4 mb-2" />
      <Skeleton className="h-3 w-1/2" />
    </div>
  )
}
